module.exports = __webpack_public_path__ + "media/images/common/header/visit-d94b172886bcf88f473278a3c5c04a8c.svg";